export default ({ instance }) => {
	return {
		consultarFaturamento(filtro) {
			return instance({
				method: "post",
				url: "financeiro/faturamento",
				data: filtro,
			});
		},
		baixarBoletoFatura(filtro) {
			return instance({
				method: "post",
				url: "financeiro/faturamento/boleto",
				data: filtro,
			});
		},
		baixarNFSFatura(filtro) {
			return instance({
				method: "post",
				url: "financeiro/faturamento/nfs",
				data: filtro,
			});
		},
	};
};
